export const END_OF_MESSAGES_FALLBACK_HEIGHT_PX = 800;
// Even with no terminal header, the top of history needs clearance from the
// floating title pill (64px header row): 44px here + the first DayDivider's
// pt-13 (52px) puts the day pill 96px down, matching the header's pt-24.
export const END_OF_MESSAGES_EMPTY_HEIGHT_PX = 44;

const TOP_PADDING_PX = 96;
const SECTION_GAP_PX = 16;
// Must equal what the deck actually renders, or the feed sizes this row from the estimate
// and then visibly resizes it once the real height lands: mt-9 (36) + the pinned 160px card
// box + pb-6 (24) + mb-25 (100). The peeks are transformed, so they add nothing to layout.
const ONBOARDING_STACK_HEIGHT_PX = 320;
const CHANNEL_CARD_HEIGHT_PX = 320;
const CHANNEL_WELCOME_HEIGHT_PX = 52;

export interface EndOfMessagesHeightContext {
  readonly hasCurrentChannel: boolean;
  readonly isMainOrSharedChannel: boolean;
  readonly isOpenBreakout: boolean;
  readonly showOnboardingCards: boolean;
}

/** Matches the fixed-height sections rendered by EndOfMessages. */
export function endOfMessagesHeight(context: EndOfMessagesHeightContext): number {
  if (!context.hasCurrentChannel) return END_OF_MESSAGES_EMPTY_HEIGHT_PX;
  // Breakouts render no header at all — no channel card.
  if (context.isOpenBreakout) return END_OF_MESSAGES_EMPTY_HEIGHT_PX;

  const sections: number[] = [];
  if (context.showOnboardingCards) sections.push(ONBOARDING_STACK_HEIGHT_PX);
  if (!context.isMainOrSharedChannel) {
    sections.push(CHANNEL_CARD_HEIGHT_PX);
    sections.push(CHANNEL_WELCOME_HEIGHT_PX);
  }

  // Main channels render only the admin onboarding deck now (no intro avatar or
  // invite button), so without it there is no terminal header at all.
  if (sections.length === 0) return END_OF_MESSAGES_EMPTY_HEIGHT_PX;

  return TOP_PADDING_PX + sections.reduce((total, height) => total + height, 0) + SECTION_GAP_PX * Math.max(0, sections.length - 1);
}
